import { useState } from 'react';
import {
  Grid,
  GridCellProps,
  GridColumn as Column,
  GridDataStateChangeEvent,
  GridNoRecords
} from '@progress/kendo-react-grid';
import { State, toDataSourceRequestString } from '@progress/kendo-data-query';
import {
  GridToolBar,
  GridToolbarDataStateChangeEvent
} from '../components/grid/grid-tool-bar';
import { DefaultGridSettings } from '../constants/grid-settings';
import { NoRecords } from '../components/grid/no-records';
import { ActionCell } from '../components/grid/actions-cell';
import Toolbar from '../components/page-toolbar';
import { useGetEnvironments } from '../hooks/services/use-environments';
import { Loader } from '@progress/kendo-react-indicators';

const initialDataState: State = {
  sort: [{ field: 'name', dir: 'asc' }],
  filter: DefaultGridSettings.initialDataState.filter,
  skip: DefaultGridSettings.initialDataState.skip,
  group: DefaultGridSettings.initialDataState.group
};

const ActiveEventsGrid = () => {
  const [dataState, setDataState] = useState<State>({
    ...initialDataState,
    take: DefaultGridSettings.initialDataState.take
  });

  const [gridMode, setGridMode] = useState<string>('grid');

  const { data, isLoading } = useGetEnvironments(
    toDataSourceRequestString(dataState)
  );

  const gridActionsColumn = (props: GridCellProps) => {
    return <AddCustomAction {...props} />;
  };

  const AddCustomAction = (props: GridCellProps) => {
    return (
      <>
        <ActionCell
          title={'Open in new tab'}
          icon={'open_in_new'}
          themeColor={'primary'}
          className={'fs-2'}
          onClick={() =>
            window.open(`${props.dataItem.hostUrl}/admin/`, '_blank')
          }
        />
      </>
    );
  };

  return (
    <>
      <Toolbar title={'Active events'}></Toolbar>
      <div
        className={'pt-2'}
        style={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
          width: '100%',
          overflow: 'hidden'
        }}>
        <GridToolBar
          searchPlaceholder={'Search environments'}
          columnsToSearch={['name']}
          showCalendarMode={false}
          showCardMode={false}
          onGridModeChange={(e) => {
            const newState = {
              ...initialDataState
            };
            if (e.gridMode === 'grid') {
              newState.take = DefaultGridSettings.initialDataState.take;
            }
            setDataState(newState);
            setGridMode(e.gridMode);
          }}
          {...dataState}
          onDataStateChange={(e: GridToolbarDataStateChangeEvent) => {
            setDataState(e.dataState);
          }}></GridToolBar>
        {gridMode === 'grid' && (
          <Grid
            id={'grid-active-events'}
            style={{
              flexGrow: 1,
              minHeight: 0,
              height: '100%',
              overflow: 'hidden'
            }}
            pageable={DefaultGridSettings.pagerSettings}
            sortable={true}
            data={data}
            {...dataState}
            onDataStateChange={(e: GridDataStateChangeEvent) => {
              setDataState(e.dataState);
            }}>
            <Column field={'name'} title={'Name'} />
            <Column field={'region'} title={'Region'} />
            <Column field={'hostUrl'} title={'Host URL'} />
            <Column
              title={'Actions'}
              cells={{ data: gridActionsColumn }}
              width={110}
            />

            <GridNoRecords>
              {isLoading ? (
                <div
                  className={
                    'd-flex flex-column align-items-center gap-2 text-muted'
                  }>
                  <Loader type={'pulsing'} />
                  <span>Loading data</span>
                </div>
              ) : (
                <NoRecords />
              )}
            </GridNoRecords>
          </Grid>
        )}
      </div>
    </>
  );
};
export default ActiveEventsGrid;
